/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */

export const fetchRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetch',
  auth: 'app',
  fingerprint: 'mdFQJXEaVZ8yMPhfqOGnCcYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchAllForUserRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetchAllForUser',
  auth: 'app',
  fingerprint: 'qNzI1F3FmcDJDB5U9l5yUMYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dismissBatchRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'dismissBatch',
  auth: 'app',
  fingerprint: 'HlLTLzK2oUC-dVpgiofIycYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dismissBatchForUserRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'dismissBatchForUser',
  auth: 'app',
  fingerprint: 'HlLTLzK2oUC-dVpgiofIycYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};